import { Grid, Tooltip, Typography } from "@material-ui/core";
import React from "react";
import "./gridControls.scss";

const UserGridLabel = (props) => {
  return (
    <div className="grid-container">
      <Tooltip title={props.value} arrow placement="right-start" >
        <Typography
          className="user-grid-label"
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            textAlign: "left",
            color: "#152C73",
            fontFamily: "Roboto",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal"
          }}
          onClick={props.action}
        >
          {props.value}
        </Typography>
      </Tooltip>
    </div>
  );
};

export default UserGridLabel;
